"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = replaceApiHost;
var root = {};

if (typeof window !== 'undefined') {
  root = window;
}
/* eslint-disable no-useless-escape */


var regApiOrigin = /^(https?\:\/\/)?((api|gw)-?(test|uat)?\.)(iyunbao\.com|baoinsurance\.com)/;
/* eslint-disable no-useless-escape */

var regOrigin = /^(https?\:\/\/)?([\.\w-]+)+(iyunbao\.com|baoinsurance\.com)/; // 替换请求地址域名（yunbao.com与baoinsurance.com)，使其与页面域名一致

function replaceApiHost(url, options) {
  var _ref = root.location || {},
      href = _ref.href;

  var hostUrl = options ? options.hostUrl : href;

  if (!hostUrl) {
    console.error('请在浏览器环境打开或者配置宿主域名！');
    return url;
  }

  var apiMatch = url.match(regApiOrigin);
  var locaMatch = hostUrl.match(regOrigin); // 验证iyunbao、baoinsurance api url

  if (apiMatch && locaMatch && apiMatch[5] !== locaMatch[3]) {
    url = url.replace(regApiOrigin, "$1$2".concat(locaMatch[3]));
  }

  return url;
}